import { Module, ActionContext } from 'vuex'
import { RootState, SMTPServiceState } from './state_models'
import SMTPService from '../models/smtp_service'

let smtpServiceListener: any;
let companySMTPServiceListener: any;

const getSmtpStoreSchema = (smtpAccount: SMTPService) => {
  return {
    id: smtpAccount.id,
    smtp_service_expired: smtpAccount.data.smtp_service_expired,
    smtp_service_error: smtpAccount.data.smtp_service_error,
    email: smtpAccount.data.email
  }
}

export const smtpServices: Module<SMTPServiceState, RootState> = {
  namespaced: true,
  state: { locationSMTPServices: [], locationId: undefined, companySMTPServices: [], companyId: undefined },
  getters: {
    getById: (state: SMTPServiceState) => {
      return (id: string) => state.locationSMTPServices.find(x => x.id === id)
    },
  },
  mutations: {
    setLocationServices: (
      state: SMTPServiceState,
      payload: { smtpServices: any[]; locationId: string }
    ) => {
      state.locationSMTPServices = payload.smtpServices
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },
    setCompanyServices: (
      state: SMTPServiceState,
      payload: { smtpServices: any[]; companyId: string }
    ) => {
      state.companySMTPServices = payload.smtpServices
      if (payload.companyId) {
        state.companyId = payload.companyId
      }
    },
    clearLocation(state: SMTPServiceState) {
      if (smtpServiceListener) {
        smtpServiceListener();
      }

      state.locationSMTPServices = []
      state.locationId = undefined
    },
    clearCompany(state: SMTPServiceState) {
      if (companySMTPServiceListener) {
        companySMTPServiceListener();
      }

      state.companySMTPServices = []
      state.companyId = undefined
    }
  },
  actions: {
    async syncAll(
      context: ActionContext<SMTPServiceState, RootState>,
      locationId: string
    ) {
      if (!locationId) {
        context.commit('clearLocation')
        return
      }


      if (context.state.locationId === locationId) {
        return context.state.locationSMTPServices
      }
      return new Promise((resolve) => {

        if (smtpServiceListener) {
          smtpServiceListener();
        }

        smtpServiceListener = SMTPService.fetchByLocationIdRealtime(locationId)
          .onSnapshot(snapshot => {
            context.commit('setLocationServices', {
              locationId: locationId,
              smtpServices: snapshot.docs.map(d => {
                const smtpAccount = new SMTPService(d)
                return getSmtpStoreSchema(smtpAccount)
              })
            })
            resolve(context.state.locationSMTPServices)
          }, err => {
            console.error(err)
            resolve(err)
          })
      })
    },
    async companySyncAll(
      context: ActionContext<SMTPServiceState, RootState>,
      companyId: string
    ) {
      if (!companyId) {
        context.commit('clearCompany')
        return
      }


      if (context.state.companyId === companyId) {
        return context.state.companySMTPServices
      }

      return new Promise((resolve) => {

        if (companySMTPServiceListener) {
          companySMTPServiceListener();
        }

        companySMTPServiceListener = SMTPService.fetchByCompanyIdRealtime(companyId)
          .onSnapshot(snapshot => {
            context.commit('setCompanyServices', {
              companyId: companyId,
              smtpServices: snapshot.docs.map(d => {
                const smtpAccount = new SMTPService(d)
                return getSmtpStoreSchema(smtpAccount)
              })
            })

            resolve(context.state.companySMTPServices)
          }, err => {
            console.error(err)
            throw err
          })
      })
    },
    logout: {
      root: true,
      handler: (context: ActionContext<SMTPServiceState, RootState>) => {
        context.commit('clearLocation')
        context.commit('clearCompany')
      }
    },
    clearAll: {
      handler: (context: ActionContext<SMTPServiceState, RootState>) => {
        context.commit('clearLocation')
        context.commit('clearCompany')
      }
    }
  }
}
